export default __webpack_public_path__ + "static/media/south-elevation.aaf92351.png";